import {registerLocaleData} from '@angular/common';
import pl from '@angular/common/locales/pl';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NgxsModule} from '@ngxs/store';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {NgxsFormPluginModule} from '@ngxs/form-plugin';
import {NZ_DATE_CONFIG, NZ_I18N, pl_PL} from 'ng-zorro-antd/i18n';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from './modules/core';
import {SharedModule} from './modules/shared';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {rootState} from './state/root.state';
import {rootService} from './services/root.service';
import {environment} from '../environments/environment';
import {IConfig, NgxMaskModule} from 'ngx-mask';
import {NgxsFormClearPluginModule} from './state/plugins/form-clear.plugin';
import {HttpErrorInterceptor} from './interceptors/http-error.interceptor';
import {LoaderInterceptor} from './interceptors/loader.interceptor';
import {NgxsSelectSnapshotModule} from '@ngxs-labs/select-snapshot';

registerLocaleData(pl);

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

const maskOptions: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        // vendor modules
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgxsModule.forRoot(rootState, {developmentMode: !environment.production}),
        NgxsFormClearPluginModule.forRoot(),
        NgxsFormPluginModule.forRoot(),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsRouterPluginModule.forRoot(),
        NgxsSelectSnapshotModule.forRoot(),
        NgxMaskModule.forRoot(maskOptions),
        // project modules
        SharedModule,
        AppRoutingModule,
        CoreModule
    ],
    providers:
        [
            rootService,
            {provide: NZ_I18N, useValue: pl_PL},
            {provide: NZ_DATE_CONFIG, useValue: {firstDayOfWeek: 1}},
            {
                provide: HTTP_INTERCEPTORS,
                useClass: HttpErrorInterceptor,
                multi: true,
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: LoaderInterceptor,
                multi: true,
            },
        ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
